<template>
  <div>
    <div class="login_banner">
      <img class="login_banimg" src="/static/loginBg.png" />
    </div>
    <div class="login_input_box">
      <img class="login_input_icon" src="/static/zhanghao.png" />
      <input class="login_input" placeholder="请输入您的账号" v-model="mobile" />
    </div>
    <div class="login_input_box">
      <img class="login_input_icon" src="/static/mima.png" />
      <input class="login_input" placeholder="请输入您的密码" v-model="password" type="password" />
    </div>
    <div class="login_botton" @click="toOrderGrabbing">登录</div>
  </div>
</template>

<script>
  import httper from '../../api/http'
  export default {
    data() {
      return {
        mobile: "",
        password: ""
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      toOrderGrabbing() {
        if (!this.mobile) {
          this.$toast({
            message: "请输入账号"
          })
          return
        }
        if (!this.password) {
          this.$toast({
            message: "请输入密码"
          })
          return
        }
        this.request("userBind", {
          mobile: this.mobile,
          password: this.password
        })
      },
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //跟单员绑定
          case 'userBind':
            httper.post('wechat/user/bind', requestData, function(res) {
              if (res.code == 0) {
                let userInfo = {}
                let userinfo = JSON.parse(localStorage.getItem('userinfo'))
                userinfo.is_bind = 5
                userInfo = userinfo
                console.log("userInfo", JSON.stringify(userInfo))
                localStorage.setItem('userinfo', JSON.stringify(userInfo))
                that.$router.push({
                  path: "/orderGrabbing"
                })
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            })
            break
        }
      },
    }
  }
</script>

<style scoped>
  .login_banner {
    width: 100%;
    height: 257px;
  }

  .login_banimg {
    width: 100%;
    height: 100%;
  }

  .login_input_box {
    width: calc(100% - 40px);
    height: 46px;
    margin: 20px;
    border: 1px solid #FD8C00;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .login_input_box1 {
    width: calc(100% - 40px);
    height: 46px;
    margin: 20px;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .login_input_icon {
    width: 23px;
    height: 23px;
    margin-right: 10px;
  }

  .login_input {
    width: 90%;
  }

  .login_botton {
    width: calc(100% - 40px);
    margin: 40px 20px;
    height: 48px;
    background: #FD8C00;
    box-shadow: 0 4px 5px 2px rgba(253, 140, 0, 0.3);
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 15px;
  }

  input {
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orderGrabbing/grabbingLogin.vue